import { render, staticRenderFns } from "./RechargeView.vue?vue&type=template&id=2392f245&scoped=true"
import script from "./RechargeView.vue?vue&type=script&lang=js"
export * from "./RechargeView.vue?vue&type=script&lang=js"
import style0 from "./RechargeView.vue?vue&type=style&index=0&id=2392f245&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2392f245",
  null
  
)

export default component.exports